import { render, staticRenderFns } from "./SortingMenu.vue?vue&type=template&id=1adb9e23&scoped=true"
import script from "./SortingMenu.vue?vue&type=script&lang=js"
export * from "./SortingMenu.vue?vue&type=script&lang=js"
import style0 from "./SortingMenu.vue?vue&type=style&index=0&id=1adb9e23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb9e23",
  null
  
)

export default component.exports